import React from 'react'
import AdminBlogList from '../../components/AdminSideComponents/DashBoardBlog/AdminBlogList'

const Blog = () => {
  return (
    <div className='bg-[#EEF3F7] p-6'>
        <AdminBlogList/>
    </div>
  )
}

export default Blog